module.exports = __webpack_public_path__ + "static/northomics-6db04e7c6deba77b86679e4943294ac6.png";